<template>
	<v-dialog
			ref="dialog"
			v-model="showDialog_"
			persistent
			width="300px">
		<template v-slot:activator="{ on }">
			<validation-provider
					:name="'AdminDatePicker-' + contentKey + '-' + inputItemKey"
					:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
					v-slot="{ errors }">
				<v-text-field
						v-model="$store.state.admin.input[inputItemKey]"
						:disabled="contents[contentKey].inputItems[inputItemKey].disabled"
						placeholder="Date"
						:error-messages="errors"
						@change="$_admnDtPckr_change()"
						v-on="on"/>
			</validation-provider>
		</template>
		<v-date-picker v-model="date_" scrollable>
			<v-spacer></v-spacer>
			<v-btn	class="customVBtn"
					color="primary"
					text
					@click="$_admnDtPckr_save()">OK</v-btn>
			<v-btn	class="customVBtn"
					color="primary"
					text
					@click="$_admnDtPckr_close()">Cancel</v-btn>
		</v-date-picker>
	</v-dialog>
</template>

<script>
	export default {
		name: 'AdminDatePicker',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		},
		data() {
			return {
				showDialog_: false,
				date_: null
			}
		},
		computed: {
			$_admnDtPckr_stateAdminUsername() {
				const self_ = this;
				return () => {
					return self_.getAdminState('username')
				}
			}
		},
		methods: {
			$_admnDtPckr_change() {
				const self_ = this;
				// input state
				const input_ = self_.getAdminState('input')
				self_.date_ = input_[self_.inputItemKey]
			},
			$_admnDtPckr_save() {
				const self_ = this;
				// input state
				const input_ = self_.getAdminState('input')
				input_[self_.inputItemKey] = self_.date_;
				self_.setAdminState('input', input_)
				// close dialog
				self_.$_admnDtPckr_close()
			},
			$_admnDtPckr_close() {
				const self_ = this;
				self_.showDialog_ = false;
			}
		}
	}
</script>

<style scoped>
</style>
